import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tog-upload-progress-bar',
  templateUrl: 'upload-progress-bar.component.html',
  styleUrls: ['upload-progress-bar.component.scss']
})
export class UploadProgressBarComponent implements OnInit {
  @Input() progressPercentage: number;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/upload-progress-bar/upload-progress-bar.component.ts